import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react';
import { AppRouter } from './routing/app-router';
import i18next from 'i18next';
import global_en from './components/localize/en/global.json'
import global_no from './components/localize/no/global.json'
import global_is from './components/localize/is/global.json'
import { I18nextProvider } from 'react-i18next';

const resources = {
  en: {
    translation: global_en
  },
  no: {
    translation: global_no
  },
  is: {
    translation: global_is
  }
}

i18next.init({
  resources,
  fallbackLng: "is",
  interpolation: {
    escapeValue: false
  }
  
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <ChakraProvider>
      <React.StrictMode>
        <I18nextProvider i18n={i18next}>
          <AppRouter />
        </I18nextProvider>
      </React.StrictMode>
    </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
